import { Trash } from "iconsax-react";
import { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { Label } from "reactstrap";
import { Href, ShowMore } from "../../../constants";
import { useAppDispatch, useAppSelector } from "../../../reduxToolkit/hooks";
import { setPropertyItem } from "../../../reduxToolkit/reducers/productSlice";
// import { routes } from "../../../routers/routes";
import { ProductBoxType } from "../../../types/Product";
import { dynamicSvg, Image } from "../../../utils";
import PropertyBoxSlider from "./common/PropertyBoxSlider";

const CarProductBox1Custom: FC<ProductBoxType> = ({ data, wishlist, view }) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { productItem } = useAppSelector((state) => state.product);

  const handleWishlist = () => toast.success("Added to Wishlist successfully");

  const handleRemove = (id: number) => {
    const updatedProductItem = productItem.filter((item) => item.id !== id);
    dispatch(setPropertyItem(updatedProductItem));
    toast.success("Remove to Wishlist successfully");
  };

  const showDescription = location.pathname.includes("listing");

  return (
    <div className="featured-box">
      <div className="featured-main-img" style={{ height: '200px' }}>
        <Link to={'/car/detail/' + data._id} className="featured-img" style={{ height: '100%', display: 'block' }}>
          <PropertyBoxSlider view={view} data={data} />
        </Link>
        {/* {wishlist ? (
          <Link to={Href} className="remove-button" onClick={() => handleRemove(data.id)}>
            <Trash className="iconsax" />
          </Link>
        ) : (
          <Link to={Href} className="save-btn" onClick={() => handleWishlist()}>
            <i className="ri-bookmark-line" />
          </Link>
        )} */}
        {data.badge && (
          <Label className={data.badge}>
            <i className='ri-verified-badge-line' />
            {data.badge}
          </Label>
        )}
      </div>
      <div className="featured-content">
        <Link to={'/car/detail/' + data._id}>{data.name}</Link>
        {showDescription && <p className="featured-detail">{data.description}</p>}
        <p>{data.emi || "-"}</p>
        {/* <ul className="featured-list">
          {data?.features?.map((item, index) => (
            <li key={index}>
              <Image src={dynamicSvg(item.icon)} alt="profile-2user" className="img-fluid" />
              <span>{item.text}</span>
            </li>
          ))}
        </ul> */}
        <ul className="featured-list">
          <li>
              <Image src={dynamicSvg('car/product/profile-2user.svg')} alt="profile-2user" className="img-fluid" />
              <span>{data.seats}</span>
            </li>
          <li>
              <Image src={dynamicSvg('car/product/gas-station.svg')} alt="profile-2user" className="img-fluid" />
              <span>{data.fuel}</span>
            </li>
          <li>
              <Image src={dynamicSvg('car/product/km.svg')} alt="profile-2user" className="img-fluid" />
              <span>{data.kilometers}</span>
            </li>
        </ul>
        <div className="featured-price">
          <h5>
            {data.price ? new Intl.NumberFormat('ms-MY', { style: 'currency', currency: 'MYR' }).format(Number(data.price)) : 'Price not available'}
          </h5>
          <Link to={'/car/detail/' + data._id} className="arrow-btn">
            {ShowMore} <i className="ri-arrow-right-up-line" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CarProductBox1Custom;
